import { NAV_IDS } from "./collections";

const itemData = [
    {
        id: NAV_IDS.READY_TO_CLOSE,
        name: "dashboard",
        label: "ready2close",
        path: "/titleCompany/",
        icon: "fas fa-house-chimney",
        theme: "blue",
        minimumPermission: "FileAdmin",
        children: [
            {
                id: NAV_IDS.READY_TO_CLOSE_SEARCH,
                path: "/titleCompany/dashboard/SelectFile",
                name: "titlecompany:fmfiles",
                label: "Search",
                minimumPermission: "FileAdmin",
            }
        ]
    },
    {
        id: NAV_IDS.FILE_MAINTENANCE,
        name: "fileMaintenance",
        label: "File",
        path: "/titleCompany/fileMaintenance",
        icon: "fas fa-file-alt",
        theme: "blue",
        minimumPermission: "FileAdmin",
        children: [
            {
                id: NAV_IDS.FILE_MAINTENANCE_DASHBOARD,
                name: "titlecompany:fmdashboard",
                label: "Dashboard",
                path: "/titleCompany/fileMaintenance/dashboard",
                minimumPermission: "FileAdmin"
            },
            {
                id: NAV_IDS.FILE_MAINTENANCE_INVITATIONS,
                name: "titlecompany:fminvitation",
                label: "Invitations",
                path: "/titleCompany/fileMaintenance/invitation",
                minimumPermission: "FileAdmin"
            },
            {
                id: NAV_IDS.FILE_MAINTENANCE_DOCUMENTS,
                name: "titlecompany:fmfilesdocument",
                label: "Documents",
                path: "/titleCompany/fileMaintenance/fileDocuments",
                minimumPermission: "FileAdmin",
                matchRoutePrefix: "titlecompany:fmfilesdocument",
            },
            {
                id: NAV_IDS.FILE_MAINTENANCE_SNUTASKS,
                name: "titlecompany:fmordertask",
                label: "Tasks",
                path: "/titleCompany/fileMaintenance/tasks",
                minimumPermission: "FileAdmin",
            },
            {
                id: NAV_IDS.FILE_MAINTENANCE_OVERRIDES,
                name: "titlecompany:fmoverrides",
                label: "Overrides",
                path: "/titleCompany/fileMaintenance/overrides",
                minimumPermission: "FileAdmin",
                children: [
                    // {
                    //     id: NAV_IDS.FILE_MAINTENANCE_OVERRIDES_FILE,
                    //     name: "titlecompany:fmoverrides:file",
                    //     label: "File Information",
                    //     path: "/titleCompany/fileMaintenance/overrides/file",
                    //     minimumPermission: "FileAdmin",
                    // },
                    {
                        id: NAV_IDS.FILE_MAINTENANCE_OVERRIDES_CONTACTS,
                        name: "titlecompany:fmoverrides:contacts",
                        label: "Contacts",
                        path: "/titleCompany/fileMaintenance/overrides/contacts",
                        minimumPermission: "FileAdmin",
                    },
                    {
                        id: NAV_IDS.FILE_MAINTENANCE_OVERRIDES_STAFF,
                        name: "titlecompany:fmoverrides:staff",
                        label: "Staff",
                        path: "/titleCompany/fileMaintenance/overrides/staff",
                        minimumPermission: "FileAdmin",
                    },
                    {
                        id: NAV_IDS.FILE_MAINTENANCE_OVERRIDES_BUYERSELLER,
                        name: "titlecompany:fmoverrides:buyerseller",
                        label: "Buyer/Seller",
                        path: "/titleCompany/fileMaintenance/overrides/buyerseller",
                        minimumPermission: "FileAdmin",
                    },
                    {
                        id: NAV_IDS.FILE_MAINTENANCE_OVERRIDES_PROPERTY,
                        name: "titlecompany:fmoverrides:property",
                        label: "Property",
                        path: "/titleCompany/fileMaintenance/overrides/property",
                        minimumPermission: "FileAdmin",
                    },
                    {
                        id: NAV_IDS.FILE_MAINTENANCE_OVERRIDES_WIRE_INSTRUCTIONS,
                        name: "titlecompany:fmoverrides:wireinstructions",
                        label: "Wire Instructions",
                        path: "/titleCompany/fileMaintenance/overrides/wireinstructions",
                        minimumPermission: "FileAdmin",
                    },
                ]
            },
        ]
    },
    {
        id: NAV_IDS.CONFIGURATION,
        name: "configuration",
        label: "Configuration",
        path: "/titleCompany/configuration",
        icon: "fas fa-cog",
        theme: "blue",
        minimumPermission: "InternalAdmin",
    }
];

export default { items: itemData };